import Splide from '@splidejs/splide'
import '@splidejs/splide/css'

const slider = () => {
  const el = document.querySelector('.hero-slider') as HTMLElement

  const slider = new Splide(el, {
    perPage: 1,
    arrows: true,
    pagination: true,
    perMove: 1,
    type: 'loop'
  })

  slider.mount()
}
export default slider
